import React, { useState } from "react";
import MaskedInput from "react-text-mask";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import Bunexe_service from "../Bunexe_service";
import DisplayInfoNS4 from "./DisplayInfoNS4";

const Verification_Inscription = () => {
  const [an9Af, setAn9Af] = useState("1617");
  const [mat9Af, setMat9Af] = useState("");
  const [info9Af, setInfo9Af] = useState([]);
  const url_ = Bunexe_service.url;

  const getInfo9AF = async () => {
    const rawMatricule = mat9Af.replace(/\D/g, "");

    if (rawMatricule.length < 8) {
      toast.error("Erreur : Le Matricule doit comporter 8 chiffres.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    try {
      const response = await fetch(
        `${url_}/recherche/info_ns4_/${an9Af}/${rawMatricule}`,
      );
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        setInfo9Af(data);
      } else {
        toast.error(
          "Information non trouvée. Veuillez consulter le directeur de votre établissement.",
          { position: toast.POSITION.TOP_RIGHT },
        );
      }
    } catch (err) {
      console.error("Erreur lors de la vérification de l'inscription :", err);
      toast.error("Erreur de connexion au serveur.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const submitform = (e) => {
    e.preventDefault();
    getInfo9AF();
  };

  return (
    <div className="row mt-4 mx-1">
      <div className="col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <div className="text-center mb-2">
          <p
            className="font-weight-bold font-italic small text-uppercase mb-1"
            style={{ letterSpacing: "1.5px" }}
          >
            Vérification Inscription NS-IV
          </p>
        </div>

        <Form
          autoComplete="off"
          noValidate
          onSubmit={submitform}
          className="border border-primary rounded-lg p-3"
        >
          <Row>
            <Form.Group as={Col} controlId="formGridAnnee">
              <Form.Label>Année 9 A.F</Form.Label>
              <Form.Control
                as="select"
                value={an9Af}
                name="an9Af"
                onChange={(e) => {
                  setAn9Af(e.target.value);
                  setInfo9Af([]);
                }}
              >
                {Array.isArray(Bunexe_service.Annee_academique) &&
                  Bunexe_service.Annee_academique.map((s, index) => (
                    <option key={index} value={s.an}>
                      {s.libelle}
                    </option>
                  ))}
              </Form.Control>
            </Form.Group>

            <Form.Group as={Col} controlId="formGridMatricule">
              <Form.Label>Matricule 9 A.F</Form.Label>
              <MaskedInput
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                className="form-control"
                placeholder="Ex: 12345678"
                value={mat9Af}
                name="mat9Af"
                id="mat9Af"
                onFocus={() => setInfo9Af([])}
                onChange={(e) => setMat9Af(e.target.value)}
                guide={true}
              />
            </Form.Group>
          </Row>

          <Button
            className="btn-block mt-3 mb-2"
            variant="primary"
            type="submit"
          >
            Vérifier
          </Button>
        </Form>

        {info9Af.length > 0 && (
          <>
            <hr />
            <DisplayInfoNS4 d={info9Af[0]} />
          </>
        )}
      </div>
    </div>
  );
};

export default Verification_Inscription;
